
<date-range-picker
  :key="localeKey"
  v-model="dateRange"
  :opens="opens"
  :timePicker="timePicker"
  :timePicker24Hour="timePicker24Hour"
  :time-picker-increment="1"
  :showDropdowns="showDropdowns"
  class="custom-date-range-picker"
  :ranges="ranges"
  :locale-data="localeAction"
  @toggle="toggleDateTimePicker"
  @update="updateValues"
>
  <template #input="picker">
    {{ picker | date(viewFormat) }}
  </template>
</date-range-picker>
